import { ActivityGroupProps } from '~/bootcamp/Activities/types/activities.types'

import ClickVariable from './Bootcamp1/ClickVariable/ClickVariable'
import CoefficientInput from './Bootcamp1/CoefficientInput/CoefficientInput'
import CoefficientOne from './Bootcamp1/CoefficientOne/CoefficientOne'
import InsertValue from './Bootcamp1/InsertValue/InsertValue'
import InsertValueCalc from './Bootcamp1/InsertValueCalc/InsertValueCalc'
import MultCoefficient1 from './Bootcamp1/MultCoefficient1/MultCoefficient1'
import MultCoefficient2 from './Bootcamp1/MultCoefficient2/MultCoefficient2'
import PowerColor from './Bootcamp1/PowerColor/PowerColor'
import PowerChoice from './Bootcamp1/PowerChoice/PowerChoice'
import UnlikeColor from './Bootcamp1/UnlikeColor/UnlikeColor'
import UnlikeInput from './Bootcamp1/UnlikeInput/UnlikeInput'
import ValueVariable from './Bootcamp1/ValueVariable/ValueVariable'
import VariableAdd from './Bootcamp1/VariableAdd/VariableAdd'
import VariableSub from './Bootcamp1/VariableSub/VariableSub'
import WhatAlgebra from './Bootcamp1/WhatAlgebra/WhatAlgebra'

const Bootcamp1Activities = ({ activityName, ...props }: ActivityGroupProps): React.ReactElement => {
  switch (activityName) {
    case 'WhatAlgebra':
      return <WhatAlgebra {...props} />
    case 'ClickVariable':
      return <ClickVariable {...props} />
    case 'ValueVariable':
      return <ValueVariable {...props} />
    case 'UnlikeColor':
      return <UnlikeColor {...props} />
    case 'CoefficientOne':
      return <CoefficientOne {...props} />
    case 'CoefficientInput':
      return <CoefficientInput {...props} />
    case 'PowerColor':
      return <PowerColor {...props} />
    case 'VariableAdd':
      return <VariableAdd {...props} />
    case 'VariableSub':
      return <VariableSub {...props} />
    case 'PowerChoice':
      return <PowerChoice {...props} />
    case 'InsertValue':
      return <InsertValue {...props} />
    case 'InsertValueCalc':
      return <InsertValueCalc {...props} />
    case 'MultCoefficient1':
      return <MultCoefficient1 {...props} />
    case 'MultCoefficient2':
      return <MultCoefficient2 {...props} />
    case 'UnlikeInput':
      return <UnlikeInput {...props} />
    default:
      return <></>
  }
}

export default Bootcamp1Activities
